export const STORAGE_APP_PREFIX = 'pd.';

// LOCAL STORAGE
export const ACCESS_TOKEN_KEY = 'access_token';
export const REFRESH_TOKEN_KEY = 'refresh_token';

// SESSION STORAGE
export const NEW_PET_ID = 'new_pet_id';
